<template>
    <div class="table-browser-word-break">
        <!-- When an alternative name type is selected -->
        <div v-if="alternativeNameSetting.included">
            <!-- When the selected alternative name type has a corresponding alternative name -->
            <div v-if="item.alternativeNames[alternativeNameSetting.selected]">
                <a :href="itemUrl">{{ item.alternativeNames[alternativeNameSetting.selected] }}</a>
                <div>
                    <small class="text-muted">{{ item.name }}</small>
                </div>
            </div>
            <!-- When selected alternative name type has no corresponding alternative name -->
            <div v-else>
                <a :href="itemUrl">{{ item.name }}</a>
            </div>
        </div>

        <!--  When no alternative name type is selected -->
        <div v-else>
            <a :href="itemUrl">{{ item.name }}</a>
        </div>

        <div>
            <small>{{ item.metadataTypeName }}</small>
            <p v-if="item.isDraft" class="text-muted">
                (Draft)
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "MetadataName",

    props: {
        item: {
            type: Object,
            required: true
        },

        alternativeNameSetting: {
            type: Object,
            required: true
        },

        isSharedSandboxView: {
            type: Boolean,
            required: true
        },

        sharedItemEndPoint: {
            type: String,
            default: ''
        }
    },

    computed: {
        itemUrl: function () {
            if (this.isSharedSandboxView) {
                return this.sharedItemEndPoint.replace('{iid}', this.item.aristotleId)
            }

            if (this.item.isDeleted) {
                return this.item.url + "?show_deleted=true"
            }

            return this.item.url
        },
    }
}
</script>
